import { KINETIC_MODULES } from './modules';

let CACHED_ENV_MODULES_LIST: KINETIC_MODULES[];

export const getEnvironmentModulesList = () => {
  if (!CACHED_ENV_MODULES_LIST) {
    const envValue = process.env.REACT_APP_KINETIC_MODULES ?? '';
    CACHED_ENV_MODULES_LIST = envValue
      ?.split(',')
      .filter((name) => name !== 'shared')
      .sort((a, b) => (a > b ? 1 : -1)) as KINETIC_MODULES[];
  }
  return CACHED_ENV_MODULES_LIST;
};
